import React from 'react';
import T from 'prop-types';
import { Route } from 'react-router-dom';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

AppRoute.propTypes = {
  component: T.oneOfType([T.node, T.func, T.object]).isRequired,
  layout: T.oneOfType([T.node, T.func]).isRequired,
};

export default AppRoute;
